import { render, staticRenderFns } from "./module-configuration.vue?vue&type=template&id=7bfa4a2a&scoped=true&"
import script from "./module-configuration.vue?vue&type=script&lang=js&"
export * from "./module-configuration.vue?vue&type=script&lang=js&"
import style0 from "./module-configuration.vue?vue&type=style&index=0&id=7bfa4a2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfa4a2a",
  null
  
)

export default component.exports